import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useState, useEffect } from 'react';
import { Typography, Button, Box, Paper, Container, CircularProgress, useTheme } from '@mui/material';
import { LanguageContext } from '../contexts/LanguageContext';
// Grounding steps
var Step;
(function (Step) {
    Step[Step["SEE"] = 0] = "SEE";
    Step[Step["TOUCH"] = 1] = "TOUCH";
    Step[Step["HEAR"] = 2] = "HEAR";
    Step[Step["SMELL"] = 3] = "SMELL";
    Step[Step["TASTE"] = 4] = "TASTE";
})(Step || (Step = {}));
var Grounding = function (_a) {
    var onProceed = _a.onProceed;
    var t = useContext(LanguageContext).t;
    var theme = useTheme();
    // States
    var _b = useState(Step.SEE), currentStep = _b[0], setCurrentStep = _b[1];
    var _c = useState(10), countdown = _c[0], setCountdown = _c[1];
    var _d = useState(false), buttonEnabled = _d[0], setButtonEnabled = _d[1];
    // Step details
    var steps = [
        { text: t('groundingSee'), number: 5 },
        { text: t('groundingTouch'), number: 4 },
        { text: t('groundingHear'), number: 3 },
        { text: t('groundingSmell'), number: 2 },
        { text: t('groundingTaste'), number: 1 },
    ];
    // Effect for countdown
    useEffect(function () {
        var timer;
        if (countdown > 0) {
            timer = setTimeout(function () {
                setCountdown(function (prev) { return prev - 1; });
            }, 1000);
        }
        else {
            setButtonEnabled(true);
        }
        return function () { return clearTimeout(timer); };
    }, [countdown]);
    // Handle proceed to next step
    var handleProceed = function () {
        if (currentStep < Step.TASTE) {
            setCurrentStep(function (prev) { return prev + 1; });
            setCountdown(10);
            setButtonEnabled(false);
        }
        else {
            onProceed(); // Proceed to next screen
        }
    };
    return (_jsx(Container, { maxWidth: "sm", sx: {
            minHeight: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            py: 2
        }, children: _jsxs(Paper, { elevation: 3, sx: {
                p: { xs: 2, sm: 4 },
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                borderRadius: 2,
                bgcolor: 'background.paper',
                width: '100%',
                minHeight: { xs: 'calc(100vh - 120px)', sm: 'auto' }
            }, children: [_jsx(Typography, { variant: "h4", component: "h1", gutterBottom: true, align: "center", children: t('groundingTitle') }), _jsx(Box, { sx: {
                        display: 'flex',
                        justifyContent: 'center',
                        width: '100%',
                        my: 3
                    }, children: [0, 1, 2, 3, 4].map(function (step) { return (_jsx(Box, { sx: {
                            width: 30,
                            height: 30,
                            borderRadius: '50%',
                            bgcolor: currentStep === step
                                ? theme.palette.primary.main
                                : currentStep > step
                                    ? theme.palette.success.main
                                    : theme.palette.grey[300],
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            color: 'white',
                            mx: 1,
                            fontWeight: 'bold',
                        }, children: 5 - step }, step)); }) }), _jsx(Box, { sx: {
                        my: 4,
                        p: 3,
                        bgcolor: theme.palette.primary.light,
                        borderRadius: 2,
                        width: '100%',
                        textAlign: 'center'
                    }, children: _jsx(Typography, { variant: "h5", color: "white", fontWeight: "medium", children: steps[currentStep].text }) }), _jsx(Box, { sx: {
                        display: 'flex',
                        justifyContent: 'center',
                        my: 3,
                        gap: 2
                    }, children: Array.from({ length: steps[currentStep].number }, function (_, i) { return (_jsx(Box, { sx: {
                            width: 40,
                            height: 40,
                            borderRadius: '50%',
                            border: "2px solid ".concat(theme.palette.primary.main),
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }, children: i + 1 }, i)); }) }), _jsxs(Box, { sx: { position: 'relative', mt: 4 }, children: [_jsx(Button, { variant: "contained", color: "primary", size: "large", disabled: !buttonEnabled, onClick: handleProceed, sx: { py: 1.5, px: 4, minWidth: 120 }, children: t('done') }), !buttonEnabled && (_jsxs(Box, { sx: {
                                position: 'absolute',
                                top: -8,
                                right: -8,
                                zIndex: 1
                            }, children: [_jsx(CircularProgress, { variant: "determinate", value: (10 - countdown) * 10, size: 36, thickness: 4 }), _jsx(Box, { sx: {
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        bottom: 0,
                                        right: 0,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }, children: _jsx(Typography, { variant: "caption", component: "div", color: "text.secondary", children: countdown }) })] }))] })] }) }));
};
export default Grounding;
